import * as React from "react";
import { IconProps } from "./types";

export const CodeSnippet02Icon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M17 17L22 12L17 7M7 7L2 12L7 17M14 3L10 21"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(CodeSnippet02Icon as React.FunctionComponent).displayName =
  "CodeSnippet02Icon";

export default CodeSnippet02Icon;
